import { render, staticRenderFns } from "./PopupRiskAnalysis.vue?vue&type=template&id=ba0ba922&scoped=true"
import script from "./PopupRiskAnalysis.vue?vue&type=script&lang=js"
export * from "./PopupRiskAnalysis.vue?vue&type=script&lang=js"
import style0 from "./PopupRiskAnalysis.vue?vue&type=style&index=0&id=ba0ba922&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba0ba922",
  null
  
)

export default component.exports